module.exports = __webpack_public_path__ + "static/img/login-bg.11d7c48c.png";